interface NoResultsProps {
  message: string;
}

const NoResults: React.FC<NoResultsProps> = ({ message }) => {
  return (
    <div className="container mx-auto my-4">
      <div className="flex items-center justify-center p-8 bg-md-gray">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default NoResults;
